import { emptyMarcaKpi } from "./pygAnaliticoBuild";

/** Marcas contables genéricas — no representan un circuito comercial */
export const isMarcaOperativa = (marca) => {
  const m = String(marca || "").trim();
  return m.length > 0 && !/^general$/i.test(m);
};

/** Prioridad para decidir si merece la pena trabajar la marca */
export const calcDetalleMarcaEconomico = (kpi) => {
  const venta = Number(kpi?.venta) || 0;
  const proyeccionVentas = Number(kpi?.proyeccionVentas) || 0;
  const pedidosVenta = Number(kpi?.pedidosVenta) || 0;
  const facturasBorradorVenta = Number(kpi?.facturasBorradorVenta) || 0;
  const compraContable = Number(kpi?.coste) || 0;
  const proyeccionCompras = Number(kpi?.proyeccionCompras) || 0;
  const pedidosCompra = Number(kpi?.pedidosCompra) || 0;
  const ventaTotal =
    venta + proyeccionVentas + pedidosVenta + facturasBorradorVenta;
  const compraTotal = compraContable + proyeccionCompras + pedidosCompra;
  // (Venta + proy. + ped. venta) − (Compra + proy. + ped. compra), signo contable
  const resultado = ventaTotal + compraTotal;
  const margenSobreVentaPct =
    ventaTotal !== 0 ? (resultado / ventaTotal) * 100 : 0;
  return {
    ventaTotal,
    compraTotal,
    compraContable,
    proyeccionVentas,
    proyeccionCompras,
    resultado,
    margenSobreVentaPct,
  };
};

export const scoreMarcaInteres = (kpi) => {
  const d = { ...emptyMarcaKpi(), ...kpi };
  const { venta, pedidosVenta } = d;
  const { resultado, margenSobreVentaPct } = calcDetalleMarcaEconomico(d);

  const pipelineFuerte = pedidosVenta >= Math.max(30000, venta * 0.15);

  let score = 0;
  const razones = [];

  if (resultado > 0) {
    score += 45;
    razones.push("Resultado positivo");
  } else if (resultado < 0 && pipelineFuerte) {
    score += 30;
    razones.push("Pérdida contable pero con pedidos fuertes");
  } else if (resultado < 0) {
    score -= 20;
    razones.push("Resultado negativo");
  }

  if (margenSobreVentaPct >= 12) {
    score += 25;
    razones.push("Margen sólido s/ venta");
  } else if (margenSobreVentaPct < 0 && venta > 0) {
    score -= 15;
  }

  if (pipelineFuerte) {
    score += 20;
    razones.push("Pipeline de pedidos venta");
  }

  if (venta < 5000 && pedidosVenta < 10000) {
    score -= 25;
    razones.push("Volumen bajo");
  }

  let prioridad = "baja";
  let prioridadLabel = "Baja prioridad";
  if (score >= 55) {
    prioridad = "alta";
    prioridadLabel = "Interesante";
  } else if (score >= 25) {
    prioridad = "media";
    prioridadLabel = "Vigilar";
  }

  return {
    score,
    prioridad,
    prioridadLabel,
    margenSobreVentaPct,
    margenContablePct: margenSobreVentaPct,
    razones,
  };
};

export const PRIORIDAD_LABELS = {
  alta: "Interesante",
  media: "A vigilar",
  baja: "Baja prioridad",
};

/** Cuenta marcas por prioridad (solo filas con datos) */
export const countMarcasByPrioridad = (rows) => ({
  alta: rows.filter((r) => r.prioridad === "alta").length,
  media: rows.filter((r) => r.prioridad === "media").length,
  baja: rows.filter((r) => r.prioridad === "baja").length,
  total: rows.length,
});

export const filterMarcasByPrioridad = (rows, filtro) => {
  if (filtro === "alta") return rows.filter((r) => r.prioridad === "alta");
  if (filtro === "media") return rows.filter((r) => r.prioridad === "media");
  if (filtro === "baja") return rows.filter((r) => r.prioridad === "baja");
  return rows;
};

export const buildMarcasChartRows = (marcas, marcasKpi) =>
  marcas
    .filter(isMarcaOperativa)
    .map((marca) => {
      const kpi = { ...emptyMarcaKpi(), ...marcasKpi[marca] };
      const economico = calcDetalleMarcaEconomico(kpi);
      const meta = scoreMarcaInteres({ ...kpi, ...economico });
      return {
        marca,
        marcaCorta: marca.length > 22 ? `${marca.slice(0, 20)}…` : marca,
        ...kpi,
        ...economico,
        ...meta,
      };
    })
    .filter(
      (r) =>
        r.venta !== 0 ||
        r.proyeccionVentas !== 0 ||
        r.compraContable !== 0 ||
        r.proyeccionCompras !== 0 ||
        r.resultado !== 0 ||
        r.pedidosVenta !== 0 ||
        r.facturasBorradorVenta !== 0 ||
        r.pedidosCompra !== 0,
    );
